// src/api/users.api.js
import api from './axios';

// لیست کل کاربران
export const getAllUsers = () => api.get('/api/client');

// دریافت اطلاعات یک کاربر
export const getUserById = (id) => api.get(`/api/client/${id}`);

// پروفایل کامل کاربر
export const getUserProfile = (userId) => api.get(`/api/client/${userId}`);

// --------------------------------------------------
// UPDATE USER PROFILE
// POST /api/client/profile/update
// OR   PUT /api/client/profile/:userId
//
// این نسخه کاملاً هماهنگ با کنترلر جدید تو است
// --------------------------------------------------
export function updateUserProfile(userId, data) {
  return api.put(`/api/client/profile/${userId}`, {
    userId,
    ...data,
  });
}

// --------------------------------------------------
// UPLOAD PROFILE PHOTO
// POST /api/client/profile/photo/upload
// Body: FormData { file, userId }
// --------------------------------------------------
export async function uploadProfilePhoto(userId, file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('userId', userId);

  return api.post(`/api/client/profile/photo/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

// --------------------------------------------------
// (Optional) UPDATE USING PATCH
// اگر بخوای فقط بخشی از دیتا را تغییر بدی
// --------------------------------------------------
export function patchUserProfile(userId, partialData) {
  return api.patch(`/api/client/${userId}`, partialData);
}

export function createClient(data) {
  return api.post('/api/client/', data);
}
